/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-03-25 10:48:20
 * @LastEditTime: 2025-04-25 14:36:49
 * @LastEditors: ywj@originqc.com
 */
import React, { useState,useEffect} from "react";
import { Modal, Button,message } from 'antd';
import process from '../../imgs/process.png'
import { openCustomerService } from '@/utils/index'
import ProcessTips from '../../../components/process-tips';
import { getBaseInfo,updateCheck } from '@/api/my-invoice'

import './index.scss';

interface IViewProps { 
  showViewModal: boolean;
  setShowViewModal: (showViewModal: boolean) => void;
  setShowApplyModal: (showApplyModal: boolean) => void;
  setIsChange: (isChange: number) => void;
  orderId?: number | string;
  id:number|string,
}

const invoiceType:any = {
  1:'数电普通发票',
  2:'数电普通发票',
  3:'数电专用发票',
}
const ViewModal: React.FC<IViewProps> = (props) => {
  const { showViewModal, setShowViewModal,setShowApplyModal,orderId='',setIsChange,id } = props;
  const [baseInfoData, setBaseInfoData] = useState<any>({})

  const handleService = () => { 
    openCustomerService();
  }

  useEffect(() => { 
    if (showViewModal) { 
      handleBaseInfo();
    }
    
  },[showViewModal])
  const handleBaseInfo = () => {
    getBaseInfo(orderId).then((res:any) => {
      if(res.success) {
        const getObj = res.obj;
        setBaseInfoData(getObj ?? {})
      }
    })
  }
// 核对订单状态，
  const handleChangeApply = () => { 
    updateCheck({id,orderId}).then((res:any) => { 
      if (res.success) {
        setShowViewModal(false);
        setShowApplyModal(true);
        setIsChange(2);
      } else { 
        message.warning(res.message)
      }
    })
  }
  return  <Modal
  width={900}
  centered
  open={showViewModal}
  title='查看发票'
  className='my-invoice-view-modal'
  onCancel={() => setShowViewModal(false)}
>
    <div className="content">
      <ProcessTips startText='提交开票申请' endText='开票申请受理'/>
      <table cellSpacing={0} className="table-box">
        <tr>
          <td className="label">发票类型</td>
          <td className="data">{ invoiceType[baseInfoData?.type]}</td>
        </tr>
        <tr>
          <td className="label">发票抬头</td>
          <td className="data">{ baseInfoData?.header}</td>
        </tr>
        {baseInfoData?.type !== 1 && <tr>
          <td className="label">纳税人识别号</td>
          <td className="data">{baseInfoData?.code}</td>
        </tr>}
        {baseInfoData?.type === 3 && <tr>
          <td className="label">注册地址</td>
          <td className="data">{baseInfoData?.address}</td>
        </tr>}
        {baseInfoData?.type === 3  && <tr>
          <td className="label">注册电话</td>
          <td className="data">{baseInfoData?.tel}</td>
        </tr>}
        {baseInfoData?.type === 3 && <tr>
          <td className="label">开户银行</td>
          <td className="data">{baseInfoData?.bankName}</td>
        </tr>}
        {baseInfoData?.type === 3 && <tr>
          <td className="label">开户行账号</td>
          <td className="data">{baseInfoData?.bankAccount}</td>
        </tr>}
        <tr>
          <td className="label">发票内容</td>
          <td className="data">{ baseInfoData?.content}</td>
        </tr>
        <tr>
          <td className="label">发票金额</td>
          <td className="data">￥{ baseInfoData?.amount}</td>
        </tr>
        <tr>
          <td className="label">申请日期</td>
          <td className="data">{ baseInfoData?.applyTime}</td>
        </tr>
      </table>
      <p className='tips'>
        <span className='red'>* </span>
        您最多仅有1次修改机会，提交修改申请前，请先与<span className="service" onClick={handleService}>【人工客服】</span>联系确认是否已经开具发票
</p>
</div>

  <div className="dialog-bottom">
    <Button className='submit-info' onClick={handleChangeApply}>修改申请</Button>
      <Button onClick={ ()=>setShowViewModal(false)}>关闭</Button>
  </div>

</Modal>
}

export default ViewModal;
